import {
  setUptimeNonceHash,
  setUptimeStateHash,
} from '~/utils/local-storage-utils/local-storage-utils';
import { generateRandomString } from '~/domain/auth/utils/crypto';
import { authConfig } from '~/config/app';

export const composeUptimeLoginUrl = () => {
  const nonce = generateRandomString();
  const state = generateRandomString();
  setUptimeNonceHash(nonce);
  setUptimeStateHash(state);

  const loginUrlUTC = authConfig.isimLoginUrl
    .concat('?client_id=')
    .concat(authConfig.isimClientId)
    .concat('&response_type=code')
    .concat(
      '&scope=openid salescompanycodeandcustomernumber groups salescompanycode profile email employeetype'
    )
    .concat('&redirect_uri=')
    .concat(encodeURIComponent(window.location.origin.concat('/uptime/callback')))
    .concat('&state=')
    .concat(state)
    .concat('&nonce=')
    .concat(nonce);
  return loginUrlUTC;
};

export const getDiamGroupId = () => {
  if (location?.pathname?.startsWith('/uptime/')) {
    const splitted = location?.pathname.split('/');
    const gid = splitted[splitted.indexOf('uptime') + 1];
    if (gid !== undefined && !gid.startsWith('callback') && gid !== 'logout') {
      return gid;
    }
  }

  return undefined;
};

export const composeUptimeLogoutUrl = (returnUrl: string) => {
  if (!process.env.ENDPOINT_ISIM_LOGOUT) {
    throw new ReferenceError('ISIM Logout Endpoint is not defined');
  }
  return process.env.ENDPOINT_ISIM_LOGOUT
    .concat('?reset-session=true&targeturl=')
    .concat(encodeURIComponent(returnUrl));
};

export const trimUptimePath = (pathname: string) => {
  const prefix = '/uptime/';
  if (pathname.startsWith(prefix)) {
    return pathname.substring(pathname.indexOf('/', prefix.length));
  }
  return pathname;
};
